export default __webpack_public_path__ + "static/media/marazzi_vivo_002.bd3ad564.jpg";